<template>
  <el-dialog v-model="formVisible" title="设备选择" width="60%">
    <div class="searchRangeDialog">
      <h-transfer
        v-model="transferKeys"
        nodeKey="treeId"
        checkedKey="userId"
        :props="{ label: 'name' }"
        :data="treeOrganPerson"
        :titles="['设备', '已选']"
      ></h-transfer>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <h-button type="primary" @click="sure()">确定</h-button>
        <h-button @click="formVisible = false">取消</h-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, toRefs, watchEffect } from "vue";
export default defineComponent({
  name: "searchRangeDialog",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(props, context) {
    const state = reactive({
      formVisible: false,
      moveVisible: false,
      transferKeys: [9]
    });
    const refData = toRefs(state);
    // const treeRef = ref(null);
    watchEffect(() => {
      state.formVisible = props.modelValue;
    });
    watchEffect(() => {
      context.emit('update:modelValue', state.formVisible);
    });
    const sure = () => {
      state.formVisible = false;
    };
    return {
      ...refData,
      sure

    };
  }
});
</script>
<style lang="scss" scoped>
// .searchRangeDialog {
// }
</style>
